import useOnce from 'hooks/useOnce';
import { getStandardVariables } from 'LoanOriginationSystemOrganization/ActionCreator';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReduxState } from 'types/redux';
import { SimplifiedVariable } from 'Variables/VariablesTypes';

const useStandardVariables = () => {
  const dispatch = useDispatch();

  const standardVariables = useSelector((state: ReduxState) => state.loanOriginationSystemOrganization.standardVariables);

  const loadStandardVariables = useOnce(() => {
    dispatch(getStandardVariables());
  });

  useEffect(() => {
    if (!standardVariables) {
      loadStandardVariables();
    }
  }, []);

  return useMemo(() => {
    if (!standardVariables) {
      return null;
    }

    return standardVariables.reduce<Record<string, SimplifiedVariable>>((standardVariablesBySystemName, standardVariable) => {
      return { ...standardVariablesBySystemName, [standardVariable.systemName]: standardVariable };
    }, {});
  }, [standardVariables]);
};

export default useStandardVariables;
